var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagUsa = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "flag-usa_svg__a",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 21,
  height: 16
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.135.968h20v15h-20z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-usa_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.135.968h20v15h-20v-15Z",
  fill: "#E31D1C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.135 2.218v1.25h20v-1.25h-20Zm0 2.5v1.25h20v-1.25h-20Zm0 3.75v-1.25h20v1.25h-20Zm0 1.25v1.25h20v-1.25h-20Zm0 3.75v-1.25h20v1.25h-20Zm0 2.5v-1.25h20v1.25h-20Z",
  fill: "#F7FCFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2E42A5",
  d: "M.135.968h11.25v8.75H.135z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m1.435 3.685.662-.461.514.37h-.29l.588.52-.2.73H2.4l-.303-.67-.257.67H1.07l.589.52-.224.821.662-.461.514.37h-.29l.588.52-.2.73H2.4l-.303-.67-.257.67H1.07l.589.52-.224.821.662-.461.641.461-.199-.82.515-.521h-.238l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521h-.238l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521h-.238l.531-.37.514.37h-.29l.588.52-.224.821.662-.461.641.461-.199-.82.515-.521h-.655l-.303-.67-.257.67h-.373l-.177-.73.515-.52h-.238l.531-.37.641.461-.199-.82.515-.521h-.655l-.303-.67-.257.67h-.373l-.177-.73.515-.52h-.238l.531-.37.641.461-.199-.82.515-.521h-.655l-.303-.67-.257.67H8.57l.589.52-.2.73h-.31l-.303-.67-.257.67h-.373l-.177-.73.515-.52h-.655l-.303-.67-.257.67H6.07l.589.52-.2.73h-.31l-.303-.67-.257.67h-.373l-.177-.73.515-.52h-.655l-.303-.67-.257.67H3.57l.589.52-.2.73h-.31l-.303-.67-.257.67h-.373l-.177-.73.515-.52h-.655l-.303-.67-.257.67H1.07l.589.52-.224.821ZM8.96 6.094l.199-.73-.589-.52h.291l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31Zm-1.349 0-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31l.2-.73-.589-.52h.291Zm-2.202.52-.2.73H4.9l-.303-.67-.257.67h-.373l-.177-.73.515-.52h-.238l.531-.37.514.37h-.29l.588.52Zm.18-.52h-.373l-.177-.73.515-.52h-.238l.531-.37.514.37h-.29l.588.52-.2.73h-.31l-.303-.67-.257.67Zm-1.63 0 .2-.73-.589-.52h.291l-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31Zm3.95-1.98-.2.73H7.4l-.303-.67-.257.67h-.373l-.177-.73.515-.52h-.238l.531-.37.514.37h-.29l.588.52Zm-2.798-.52-.514-.37-.53.37h.237l-.515.52.177.73h.373l.257-.67.303.67h.31l.2-.73-.589-.52h.291Z",
  fill: "#F7FCFF"
}))));
export default SvgFlagUsa;